/**
 * Created by zzy on 2019/7/23.
 */
import AppHeader from './AppHeader.vue'
export default AppHeader



// WEBPACK FOOTER //
// ./src/components/appHeader/index.js